var _g, _path, _rect, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 90,
    viewBox: "0 0 89 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_221_3150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 19.6602,
    width: 38.81,
    height: 38.81,
    rx: 10,
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 20.1602,
    width: 37.81,
    height: 37.81,
    rx: 9.5,
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8591 46.6123H34.5189C34.5189 47.1126 34.7176 47.5925 35.0714 47.9463C35.4252 48.3001 35.9051 48.4989 36.4055 48.4989C36.9058 48.4989 37.3857 48.3001 37.7395 47.9463C38.0933 47.5925 38.2921 47.1126 38.2921 46.6123H43.9519C44.202 46.6123 44.442 46.5129 44.6189 46.336C44.7958 46.1591 44.8952 45.9191 44.8952 45.669C44.8952 45.4188 44.7958 45.1788 44.6189 45.0019C44.442 44.825 44.202 44.7257 43.9519 44.7257V38.1226C43.9519 36.1211 43.1568 34.2017 41.7416 32.7865C40.3263 31.3712 38.4069 30.5762 36.4055 30.5762C34.404 30.5762 32.4846 31.3712 31.0694 32.7865C29.6541 34.2017 28.8591 36.1211 28.8591 38.1226V44.7257C28.6089 44.7257 28.369 44.825 28.1921 45.0019C28.0152 45.1788 27.9158 45.4188 27.9158 45.669C27.9158 45.9191 28.0152 46.1591 28.1921 46.336C28.369 46.5129 28.6089 46.6123 28.8591 46.6123V46.6123ZM30.7457 38.1226C30.7457 36.6215 31.342 35.1819 32.4034 34.1205C33.4648 33.0591 34.9044 32.4628 36.4055 32.4628C37.9065 32.4628 39.3461 33.0591 40.4075 34.1205C41.469 35.1819 42.0653 36.6215 42.0653 38.1226V44.7257H30.7457V38.1226Z",
    fill: "#FF3D53"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44.087,
    y: 13.5958,
    width: 17.7879,
    height: 17.7879,
    rx: 8.89396,
    fill: "#FF3D53",
    stroke: "#F3F2F7",
    strokeWidth: 2.42563
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4775 26.6172C49.3999 26.6172 49.3513 26.5687 49.3513 26.4911V26.1321C49.3513 26.0738 49.3708 26.0253 49.4096 25.9768C50.1761 25.0648 50.9038 24.1528 51.6023 23.2795C52.1748 22.5518 52.5144 21.9406 52.5144 21.4846C52.5144 20.8054 52.0098 20.3494 51.253 20.3494C50.5157 20.3494 50.0208 20.8054 50.0305 21.4943V21.7659C50.0305 21.8436 49.982 21.8921 49.9044 21.8921H49.4581C49.3805 21.8921 49.3319 21.8436 49.3319 21.7659V21.4069C49.3611 20.4076 50.1567 19.7478 51.253 19.7478C52.4464 19.7478 53.2129 20.4755 53.2129 21.4749C53.2129 22.0473 52.8928 22.7071 52.3009 23.4639C51.68 24.2789 50.9911 25.1036 50.2925 25.9574C50.2634 25.9865 50.2828 26.0156 50.3216 26.0156H53.2906C53.3682 26.0156 53.4167 26.0641 53.4167 26.1418V26.4911C53.4167 26.5687 53.3682 26.6172 53.2906 26.6172H49.4775ZM55.5169 19.8642C55.5654 19.8351 55.6236 19.8254 55.6819 19.8254H56.1573C56.2349 19.8254 56.2834 19.8739 56.2834 19.9516V26.4911C56.2834 26.5687 56.2349 26.6172 56.1573 26.6172H55.7207C55.643 26.6172 55.5945 26.5687 55.5945 26.4911V20.5822C55.5945 20.5531 55.5751 20.524 55.5363 20.5434L54.5176 20.9703C54.4302 21.0091 54.372 20.9606 54.372 20.8733V20.5725C54.372 20.5046 54.3914 20.4658 54.4593 20.427L55.5169 19.8642Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_221_3150",
    x: 0,
    y: 0.660156,
    width: 88.8101,
    height: 88.8101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_221_3150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_221_3150",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.9d1339b94314264466de429a4588b353.svg";
export { ForwardRef as ReactComponent };